const Themes = {
  'Esri Street': {
    link: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}.png',
    attribution: '&copy; ESRI <a href="http://www.esri.com/legal/licensing/termsofuse.html">(ESRI Terms of Use)</a>',
    opacity: 1
  },
  'Esri Topo': {
    link: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.png',
    attribution: '&copy; ESRI <a href="http://www.esri.com/legal/licensing/termsofuse.html">(ESRI Terms of Use)</a>',
    opacity: 1
  },
  Hot: {
    link: 'https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.',
    opacity: 1
  },
  Light: {
    link: 'https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    opacity: 1
  },
  Dark: {
    link: 'https://{a-c}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    opacity: 1
  },
  Voyager: {
    link: 'https://{a-c}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    opacity: 1
  },
  OpenTopoMap: {
    link: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.',
    opacity: 1
  },
  OSM: {
    link: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png ',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.',
    opacity: 1
  },
};

export default Themes;
